import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Boîte de confirmation qui remplace le `confirm()` natif du navigateur.
//
// Au montage, elle s'enregistre auprès de Turbo : tout élément portant
// `data-turbo-confirm="…"` déclenche cette boîte au lieu de l'alerte du navigateur, sans
// avoir à être retouché.
//
// `ask(message)` affiche la boîte et renvoie une promesse résolue à true (Confirmer) ou
// false (Annuler, clic sur le voile, ou Échap).
export default class extends Controller {
  // Pas de cible `root` : Stimulus ne cherche ses cibles que parmi les DESCENDANTS de
  // l element du controleur, et la racine est cet element lui-meme. Declaree en cible,
  // elle restait introuvable — et `ask()` levait dans la promesse rendue a Turbo, donc
  // sans rien afficher ni dans la page ni dans la console.
  static targets = ["message"]

  connect() {
    this.resolve = null
    this.onKeydown = this.onKeydown.bind(this)
    // L API a change entre les versions de Turbo : `Turbo.config.forms.confirm` depuis
    // la 8.x, `setConfirmMethod` avant. On prend la premiere qui existe plutot que de
    // supposer une version — le projet de reference tourne sur lancienne, et une
    // deprecation silencieuse ne se voit qua lusage.
    if (Turbo.config?.forms) {
      Turbo.config.forms.confirm = (message) => this.ask(message)
    } else {
      Turbo.setConfirmMethod((message) => this.ask(message))
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  ask(message) {
    this.messageTarget.textContent = message
    this.element.classList.remove("hidden")
    document.addEventListener("keydown", this.onKeydown)
    return new Promise((resolve) => { this.resolve = resolve })
  }

  confirm() { this.close(true) }
  cancel() { this.close(false) }

  onKeydown(event) {
    if (event.key === "Escape") this.close(false)
    else if (event.key === "Enter") this.close(true)
  }

  close(result) {
    this.element.classList.add("hidden")
    document.removeEventListener("keydown", this.onKeydown)
    if (this.resolve) {
      this.resolve(result)
      this.resolve = null
    }
  }
}
